import Axios from 'axios';
import {
  message
} from 'ant-design-vue';
import {
  router
} from '../router';
import store from '../store';
import { getToken, removeToken } from '@/libs/storage';
import { baseURL } from '../utils/baseUrl.js';
let baseUrl = '';
if (process.env.NODE_ENV === 'development') {
  baseUrl = `./api`;
} else {
  baseUrl = './';
}
// 创建实例，初始化头部
const Request = Axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  crossDomain: true
});
// // 添加请求拦截器
Request.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// 添加响应拦截器
Request.interceptors.response.use(
  response => {
    if (response.data.code == '401') {
      message.error(response.data.message);
      removeToken();
      if (router.app.$route.path != '/login') {
        router.push({
          path: '/login'
        })
      }
      return Promise.reject(response.data); // 返回接口返回的错误信息
    } else {
      return response.data;
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误(400)';
          break;
        case 401:
          localStorage.removeItem('authorization');
          router.push({
            path: '/login'
          })
          error.message = '登录已过期, 重新登录';
          break;
        case 402:
          localStorage.removeItem('authorization');
          router.push({
            path: '/login'
          })
          error.message = '账号状态异常, 请联系管理员';
          break;
        case 405:
          error.message = '缺少appid,请从菜单登录';
          break;
        case 403:
          error.message = '拒绝访问(403)';
          break;
        case 404:
          error.message = '请求出错';
          break;
        case 408:
          error.message = '请求超时(408)';
          break;
        case 500:
          error.message = '服务器错误(500)';
          break;
        case 501:
          error.message = '服务未实现(501)';
          break;
        case 502:
          error.message = '网络错误(502)';
          break;
        case 503:
          error.message = '服务不可用(503)';
          break;
        case 504:
          error.message = '网络超时(504)';
          break;
        case 505:
          error.message = 'HTTP版本不受支持(505)';
          break;
        default:
          error.message = `连接出错(${error.response.status})!`;
      }
      message.error(error.message);
      return Promise.reject(error.response.data); // 返回接口返回的错误信息
    } else {
      message.error(error.message);
      return Promise.reject(error); // 返回接口返回的错误信息
    }
  }
);

export default Request;



// WEBPACK FOOTER //
// ./src/api/request.js